/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/mine_orbital': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M8 19h14v4H8zM6 17h18v1H6zM19 24a2 2 0 100 4 2 2 0 000-4zm-.042 3a1 1 0 110-2 1 1 0 010 2zM11.042 24a2 2 0 100 4 2 2 0 000-4zM11 27a1 1 0 110-2 1 1 0 010 2zM14 24h2v2h-2zM6 24h2v2H6zM22 24h2v2h-2zM10 16l5-5 5 5zM8 4h1v5H8z"/><path pid="1" d="M6 6h5v1H6zM23 10h1v3h-1z"/><path pid="2" d="M22 11h3v1h-3zM15 32H0V17h1v14h14zM32 32H17v-1h14V17h1zM32 15h-1V1H17V0h15zM1 15H0V0h15v1H1z"/>'
  }
})
